import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_FILE_ENV_CONFIG_LIST } from "./EnvConfig.constants";
const EnvConfigList = Loadable(
  lazy(() =>
    import("./EnvConfigList").then(({ EnvConfigList }) => ({
      default: EnvConfigList,
    }))
  )
);

export const EnvConfigRoutes = [
   {
          path: `${APP_FILE_ENV_CONFIG_LIST}`,
          exact: true,
          element: (
            <AuthorizedRoute allowFullAccess moduleKeys={[]}>
              <EnvConfigList />
            </AuthorizedRoute>
          ),
        },
];
